import { colors } from "../../data/colors";
import { stdObject } from "../../data/types/stdObject";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function TransferRecords({
  title,
  previous,
  next,
}: {
  title: string | boolean;
  previous: stdObject[];
  next: stdObject[];
}) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: 5,
        borderRadius: 5,
        border: "solid 2px " + colors.darkGrey,
      }}
    >
      <table>
        <tbody>
          <tr>
            {previous.length > 0 && (
              <>
                <td>
                  {previous.map((e: stdObject, index: number) => (
                    <div
                      key={index}
                      className="transferBox noSelect"
                      style={{ backgroundColor: colors.blue }}
                    >
                      {t(`c.${e.DOCNEX === "PRE" ? "PREP" : e.DOCNEX}`)}{" "}
                      {e.SERNEX}-{e.CODNEX}
                    </div>
                  ))}
                </td>
                <td>
                  <ArrowForwardIcon
                    style={{
                      fontSize: 15,
                    }}
                  />
                </td>
              </>
            )}
            <td>
              <div
                className="transferBox noSelect"
                style={{ backgroundColor: colors.darkGrey }}
              >
                {title}
              </div>
            </td>
            {next.length > 0 && (
              <>
                <td>
                  <ArrowForwardIcon
                    style={{
                      fontSize: 15,
                    }}
                  />
                </td>
                <td>
                  {next.map((e: stdObject, index: number) => (
                    <div
                      key={index}
                      className="transferBox noSelect"
                      style={{ backgroundColor: colors.green }}
                    >
                      {t(`c.${e.DO2NEX === "PRE" ? "PREP" : e.DO2NEX}`)}{" "}
                      {e.SE2NEX}-{e.CO2NEX}
                    </div>
                  ))}
                </td>
              </>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
